import _ from 'lodash';
import log from './log.js';
import config from './config.js';

var get = function get() {
  return new Promise(function (resolve, reject) {
    var kcToken = config.get('kcToken');

    if (typeof window !== 'undefined') {
      window.kc.updateToken().success(function () {
        resolve(window.kc.token);
      }).error(function () {
        log.error('window.kc failed to updateToken');
        var callback = config.get('sessionExpiredCallback');

        if (callback) {
          if (_.isFunction(callback)) {
            callback();
          } else {
            console.warn('sessionExpiredCallback is not a function; ignoring');
          }
        }

        reject();
      });
    } else if (kcToken !== undefined) {
      resolve(kcToken);
    } else {
      reject('something is odd here.');
    }
  });
};

export default {
  get: get
};